<template>
  <div class="edu_pages">
    <!-- <div class="edu_pages_content_top">
      <div class="edu_header_title">角色成员</div>
    </div> -->
    <div class="edu_pages_content">
      <div class="edu_pages_content_header">
        <div class="edu_pages_content_header_left">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-back"
            @click="$Common.pageJump('/edu_authority', 3)"
            >返回</el-button
          >
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="openAddBox()"
            >添加成员</el-button
          >
        </div>
      </div>
      <!-- 角色成员管理 -->
      <div class="edu_pages_content_body">
        <el-table
          :data="responseData.list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="selectListData"
        >
          <el-table-column type="selection" width="70" align="center">
          </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                responseData.pageSize * (responseData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户姓名"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="userPhone"
            label="联系方式"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="操作"
            column-key="index"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <div class="text-center">
                <el-button
                  type="danger"
                  size="mini"
                  plain
                  icon="el-icon-circle-close"
                  @click="delDataInfo(scope.row.userId)"
                >
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="edu_pages_content_bottom" v-if="responseData.total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="responseData.pageNum"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          prev-text="上一页"
          next-text="下一页"
          :total="responseData.total"
        >
        </el-pagination>
      </div>

      <el-dialog
        title="添加成员"
        :append-to-body="true"
        :modal-append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="40%"
        :before-close="handleClose"
        :visible.sync="showDialog"
        direction="ltr"
      >
        <div
          style="display: flex;
      justify-content: center;
      align-items: center;"
        >
          <el-transfer
            v-model="addDataList"
            :props="{
              key: 'userId',
              label: 'userName',
              disabled: 'disabledSelect'
            }"
            :titles="['待选择成员列表', '待提交成员列表']"
            :data="userDataList"
            filterable
            :filter-method="filterMethod"
            filter-placeholder="请输入成员名称"
          >
            <el-button
              class="transfer-footer"
              type="primary"
              style="float:right;margin:5px"
              slot="right-footer"
              size="small"
              :disabled='addDataList.length > 0 ? false : true'
              @click="addDataAction()"
              >提交</el-button
            >
          </el-transfer>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      addBox: false,
      responseData: {
        pageNum: 1, // 第几页
        pageSize: 20, // 一页多少个
        total: 0, // 总条数
        pages: 0, // 总页数
        list: [] // 数据列表
      },

      requestData: {
        pageNum: 1,
        pageSize: 20
      },
      roleInfo: JSON.parse(sessionStorage.getItem("roleInfo")) || "",
      departmentList: [],
      selectedListData: [],
      userListRequestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 20,
        userPhone: "",
        userName: "",
        departmentId: ""
      },
      userDataList: [],
      addDataList: [],
      selectedDepartmentId: "",
      showDialog: false,
      filterMethod(query, item) {
        return item.userName.indexOf(query) > -1;
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    userSizeChange(val) {
      this.listRequestData.pageNum = 1;
      this.listRequestData.pageSize = val;
      // console.log(`每页 ${val} 条`);
      this.getDataList();
    },
    userCurrentChange(val) {
      this.listRequestData.pageNum = val;
      // console.log(`当前页: ${val}`);
      this.getDataList();
    },
    async getUserDataList() {
      let res = await this.$Http.getEduUserList(this.userListRequestData);
      if (res.code == 200) {
        let list = res.data.list || [];
        this.userDataList = list.map((item,index)=>{
          item.disabledSelect = item.roleName == '' ? false : true
          return item
        })
      } else if (res.code == 101) {
        this.userDataList = []
      } else {
        this.userDataList = []
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    delDataInfo(thisId = 0) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          if (thisId >= 1) {
            var requestData = {
              userId: thisId
            };
          } else {
            if (this.selectedListData.length < 1) {
              this.$message({
                type: "error",
                message: "请先选择您要删除的数据"
              });
              return false;
            }
            var requestData = this.selectedListData;
          }

          let res = await this.$Http.delRoleMember(requestData, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    openAddBox() {
      this.showDialog = true;
      this.getUserDataList();
    },
    async addDataAction() {
      let req = this.addDataList.map((item) => {
        return { userId: item, roleId: this.roleInfo.roleId };
      });
      let res = await this.$Http.addRoleMember(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.addDataList = [];
        this.getDataList();
        this.showDialog = false;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    handleSizeChange(data) {
      this.requestData.pageSize = data;
      this.getDataList();
    },
    handleCurrentChange(data) {
      this.requestData.pageNum = data;
      this.getDataList();
    },
    selectListData(data) {
      this.selectedListData = [];
      data.forEach((element) => {
        this.selectedListData.push(element.id);
      });
    },
    // 获取数据列表
    async getDataList() {
      var parameData = {
        pageNum: this.requestData.pageNum,
        pageSize: this.requestData.pageSize,
        roleId: this.roleInfo.roleId
      };
      let res = await this.$Http.getRoleMemberList(parameData, true);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    handleClose() {
      this.showDialog = false;
      this.addDataList = [];
    }
  },
  created() {},
  mounted() {
    if (this.roleInfo == "") {
      this.$Common.pageJump("/authority_settings", 3);
    }
    this.getDataList();
    this.getUserDataList();
  }
};
</script>
<style scoped>
@import "/css/base.css";
@import "/css/authority.css";
</style>
